import { useState, type FormEvent } from 'react';
import { changeOwnPassword } from '../../data/accounts.ts';
import { toAppError } from '../../data/errors.ts';
import { hasErrors, PASSWORD_MIN_LENGTH, validateNewPassword, type PasswordErrors } from '../../domain/password.ts';
import { Button } from '../../ui/Button.tsx';
import { Field } from '../../ui/Field.tsx';
import { useNotices } from '../../ui/notices-context.ts';

interface PasswordFormProps {
  submitLabel: string;
  onChanged: () => void | Promise<void>;
}

// Cambio de la propia contraseña (§3): nueva + repetición, validación, guardar y limpiar campos.
export function PasswordForm({ submitLabel, onChanged }: PasswordFormProps) {
  const notices = useNotices();
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [errors, setErrors] = useState<PasswordErrors>({});
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    const validation = validateNewPassword(password, repeat);
    setErrors(validation);
    if (hasErrors(validation)) return;
    setBusy(true);
    try {
      await changeOwnPassword(password);
      setPassword('');
      setRepeat('');
      notices.info('Tu contraseña se actualizó correctamente.');
      await onChanged();
    } catch (error) {
      notices.error(toAppError(error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="form" onSubmit={submit} noValidate>
      <Field
        label="Contraseña nueva"
        type="password"
        autoComplete="new-password"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={errors.password}
        hint={`Mínimo ${PASSWORD_MIN_LENGTH} caracteres.`}
      />
      <Field
        label="Repite la contraseña nueva"
        type="password"
        autoComplete="new-password"
        required
        value={repeat}
        onChange={(e) => setRepeat(e.target.value)}
        error={errors.repeat}
      />
      <Button type="submit" busy={busy}>
        {submitLabel}
      </Button>
    </form>
  );
}
